import ImageSwiperComponent from '../../views/image-swiper/base/swiper' 
import PostSwiperComponent from '../../views/post-swiper/base/swiper' 
import VenueSwiperComponent from '../../views/venue-swiper/swiper' 
import HeaderComponent from '../../views/header/header' 
// import FooterComponent from '../../views/footer/footer' 
import HeroComponent from '../../views/hero/hero'  
import TimelineComponent from '../../views/timeline/timeline' 
import MasonryGalleryComponent from '../../views/masonry-gallery/masonry-gallery' 
import VenueComponent from '../../views/loop/venueComponent' 

const components = {
  ImageSwiperComponent,
  HeaderComponent,   
  // FooterComponent,   
  HeroComponent, 
  PostSwiperComponent,
  VenueSwiperComponent,
  TimelineComponent,
  MasonryGalleryComponent,
  VenueComponent
}

export default components;